import { deleteChatSession } from './deleteChatSession'
import { disableChat } from './disableChat'

/**
 * @param {LCChatDisconnectedEvent} payload
 */
export function handleChatDisconnected(payload) {
  console.info('chat disconnected:', payload)

  deleteChatSession()
  disableChat()
}
